import { BEMBlock } from '@helpers/classnames';
import '../styles/GlobalSearchResultsBlock.scss';

interface GlobalSearchResultsBlockProps {
    children: React.ReactNode;
}

function GlobalSearchResultsBlock({ children }: GlobalSearchResultsBlockProps) {
    const [block] = BEMBlock('global-search-results-block');

    return (
        <div className={block}>
            {children}
        </div>
    );
}

export default GlobalSearchResultsBlock;
